import { Attr, BaseSchema, IQuery, ModelSchema } from './helpers'
import { UserSchema } from './UserSchema'
import { CommentThreadSchema } from './CommentThreadSchema'

@ModelSchema({
  name: 'comment',
  description: 'A comment as part of a thread',
  version: 0,
  required: ['user_id', 'thread_id', 'content'],
  indexes: ['created_at'],
  associations: () => [
    { type: 'belongsTo', model: UserSchema, key: 'user', foreignKey: 'user_id' },
    { type: 'belongsTo', model: CommentThreadSchema, key: 'thread', foreignKey: 'thread_id' },
  ],
})
export class CommentSchema extends BaseSchema {
  static QUERIES = {
    ...BaseSchema.QUERIES,
    orderedThread(thread_id: string): IQuery { return { selector: { thread_id }, sort: [{ created_at: 'asc' }] } },
  }

  @Attr({ type: 'string' }) content: string

  user_id: string
  thread_id: string
}
